// Name component after their filename.
export default (filename = '', C) => {
  C.displayName = filename.match(/\/([^/]+)\.[^.]+/)[1];
  return C;
};



// WEBPACK FOOTER //
// ./src/helpers/fn.js